module.exports = __webpack_public_path__ + "img/17406741002628.b07f8204.png";